/** Supported UI locales. English and French are required for all user-facing copy. */
export type LocaleId = 'en' | 'fr';

export const SUPPORTED_LOCALES: readonly LocaleId[] = ['en', 'fr'] as const;

export const DEFAULT_LOCALE: LocaleId = 'en';

export const LOCALE_STORAGE_KEY = 'dsc-ols-locale';
